import { Component, DoCheck, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SearchRequestEnvelope } from '../../../models/net/envelope/search-request-envelope';
import { SearchRequest } from '../../../models/data/app-core/search-request';
import { AppMessage } from '../../../interfaces/app-message';
import { AppService } from '../../../services/app.service';
import { SearchRequestBase } from '../../../models/net/request/base/search-request-base';
import { EmbeddableTileComponent } from '../../../interfaces/embeddable-tile-component';
import { MessageSeverity } from '../../../enums/message-severity';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { SearchRequestService } from '../../../services/search-requests/search-request.service';
import { CreateResult } from '../../../models/net/result/crud/create-result';
import { UpdateResult } from '../../../models/net/result/crud/update-result';
import { DeleteResult } from '../../../models/net/result/crud/delete-result';
import { MatButton } from '@angular/material/button';
import { ComponentDialogComponent } from '../../component-dialog/component-dialog.component';

@Component({
    selector: 'app-search-tile',
    templateUrl: './search-tile.component.html',
    styleUrls: ['./search-tile.component.css', '../../../app.component.css']
})

export class SearchTileComponent implements OnInit, DoCheck, OnDestroy, EmbeddableTileComponent {

    public isAdhoc: boolean = false;
    public itemEnvelope: SearchRequestEnvelope = new SearchRequestEnvelope(null);
    public itemEnvelopeSnapshot: SearchRequestEnvelope | undefined;
    public itemSearchRequest: any | undefined; // SearchRequestBase = new SearchRequestBase();
    public itemSearchRequestSnapshot: any | undefined; // SearchRequestBase = new SearchRequestBase();
    public isPendingChanges: boolean = false;
    public saveButtonCaption: string = "";
    public appFeedMessages: AppMessage[] = [];
    public isAppFeedPaneCollapsed: boolean = true;
    public appFeedPaneDynamicClassName: string = "appfeed-pane-expanded";
    public appFeedButtonDynamicClassName: string = "appfeed-button-pane-expanded";
    public isPreviouslyDisplayedBasicTabHint: boolean = false;
    public isPreviouslyDisplayedAdvancedTabHint: boolean = false;
    public isAdvancedTabAvailable: boolean = false;
    public componentDialogComponent?: ComponentDialogComponent;

    @ViewChild("tabGroup") tabGroup!: MatTabGroup;
    @ViewChild("advancedSearchTab") advancedSearchTab!: MatTab;

    @ViewChild("saveButton") saveButton!: MatButton;

    @Output() pendingChangesStateChanged = new EventEmitter<boolean>();
    @Output() setAcceptButtonCaption = new EventEmitter<string>();
    @Output() setCloseButtonCaption = new EventEmitter<string>();
    @Output() closeContainerRequest = new EventEmitter();
    @Output() setIsDataSourceAltered = new EventEmitter<boolean>();

    public constructor(public appService: AppService, public searchRequestService: SearchRequestService) { }

    public ngOnInit(): void {

        const s: string = "";
    }

    public setDataSource = (dataSource: SearchRequestEnvelope, componentDialogComponent: ComponentDialogComponent): void => {

        this.componentDialogComponent = componentDialogComponent;
        this.itemEnvelope = dataSource;
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.itemSearchRequest = JSON.parse(this.itemEnvelope.Document.Item.SearchRequestJson) as SearchRequestBase;
        this.itemSearchRequestSnapshot = this.appService.cloneObject(this.itemSearchRequest);

        this.saveButtonCaption = this.itemSearchRequest.IsAdvancedSearch ? "SAVE AS ADVANCED SEARCH" : "SAVE AS BASIC SEARCH";
        this.isAdvancedTabAvailable = true;

        this.addAppFeedMessage(MessageSeverity.Info, "Save and / or run a basic search (this search request is not advanced search capable)", false);
    }

    public addAppFeedMessage = (severity: MessageSeverity, message: string, isShowAppfeedPane: boolean): void => {

        const newMessage: AppMessage = {
            MessageDateTime: new Date,
            MessageSeverity: severity,
            MessageText: message
        };

        this.appFeedMessages.unshift(newMessage);

        if (isShowAppfeedPane) {

            this.openAppFeedPane(0);
        }
    }

    public openAppFeedPane = (closeAfterMilliseconds: number = 0): void => {

        if (this.isAppFeedPaneCollapsed) {

            this.appFeedPaneDynamicClassName = "appfeed-pane-expanded";
            this.appFeedButtonDynamicClassName = "appfeed-button-pane-expanded";
            this.isAppFeedPaneCollapsed = false;
        }

        if (closeAfterMilliseconds > 0) {

            setTimeout(() => {

                this.appFeedPaneDynamicClassName = "appfeed-pane-collapsed";
                this.appFeedButtonDynamicClassName = "appfeed-button-pane-collapsed";
                this.isAppFeedPaneCollapsed = true;
            }, closeAfterMilliseconds);
        }
    }

    public ngDoCheck(): void {

        const isPendingChanges = this.isPendingChanges;

        if (JSON.stringify(this.itemEnvelope) != JSON.stringify(this.itemEnvelopeSnapshot)
            || JSON.stringify(this.itemSearchRequest) != JSON.stringify(this.itemSearchRequestSnapshot)) {

            this.itemEnvelope!.Document!.Item.SearchRequestJson = JSON.stringify(this.itemSearchRequest);
            this.isPendingChanges = true;

        } else {

            this.isPendingChanges = false;
        }

        if (this.isPendingChanges != isPendingChanges) {

            this.pendingChangesStateChanged.emit(this.isPendingChanges);
            this.setCloseButtonCaption.emit("CANCEL AND CLOSE");
        }
    }

    public ngAfterViewInit(): void {

        this.setAcceptButtonCaption.emit(this.itemSearchRequest.IsAdvancedSearch ? "RUN AS ADVANCED SEARCH" : "RUN AS BASIC SEARCH");
        this.setCloseButtonCaption.emit("CLOSE");
        this.pendingChangesStateChanged.emit(true); // activate the accept button

        //this.setAdvancedSearchAvailability();

        const saveButtonReference: any = this.saveButton;
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 0) {

            this.addAppFeedMessage(MessageSeverity.Info, this.itemSearchRequest.BasicSearchDescription, false);

            this.itemSearchRequest.IsAdvancedSearch = false;
            this.saveButtonCaption = "SAVE AS BASIC SEARCH";
            this.setAcceptButtonCaption.emit("RUN BASIC SEARCH");

        } else {

            this.addAppFeedMessage(MessageSeverity.Info, "Advanced searches present more fields and options to fine-tune search criteria", false);

            this.itemSearchRequest.IsAdvancedSearch = true;
            this.saveButtonCaption = "SAVE AS ADVANCED SEARCH";
            this.setAcceptButtonCaption.emit("RUN AS ADVANCED SEARCH");
        }
    }

    //public setAdvancedSearchAvailability = (): void => {

    //    if (this.advancedSearchTab) {

    //        try {

    //            this.advancedSearchTab.disabled = !this.itemSearchRequest.IsAdvancedSearchCapable;

    //        } catch (e) {

    //            const s: string = "";
    //        }
    //    }
    //}

    public save(): void {

        if (this.itemEnvelope!.Document!.Item.Name.trim() == "") {

            this.addAppFeedMessage(MessageSeverity.Warning, "Please enter a Name before saving", false);

        } else {

            this.itemEnvelope!.Document!.Item.SearchRequestJson = JSON.stringify(this.itemSearchRequest);

            if (this.itemEnvelope!.Document!.Item.SearchRequestId <= 0) {

                this.searchRequestService.create(this.itemEnvelope).subscribe((r: CreateResult | null) => {

                    if (r) {

                        if (r.IsSuccess) {

                            this.setDataSource(r.CreatedEnvelope, this.componentDialogComponent!);
                            this.setIsDataSourceAltered.emit(true);
                            this.setCloseButtonCaption.emit("CLOSE");
                            this.isPendingChanges = false;
                            this.addAppFeedMessage(MessageSeverity.Success, "Successfully created new " + (this.itemSearchRequest.IsAdvancedSearch ? "advanced" : "basic") + " search.  This search is now in your list of saved searches !", false);

                        } else {

                            this.addAppFeedMessage(MessageSeverity.Error, "There was an error creating the new saved search request.  Error details: " + r.Message, false);
                        }
                    }
                });

            } else {

                this.searchRequestService.update(this.itemEnvelope).subscribe((r: UpdateResult | null) => {

                    if (r) {

                        if (r.IsSuccess) {

                            this.setDataSource(r.UpdatedEnvelope, this.componentDialogComponent!);
                            this.setIsDataSourceAltered.emit(true);
                            this.setCloseButtonCaption.emit("CLOSE");
                            this.isPendingChanges = false;
                            this.addAppFeedMessage(MessageSeverity.Success, "Successfully saved changes.  You can re-run this " + (this.itemSearchRequest.IsAdvancedSearch ? "advanced" : "basic") + " at a later time with the saved criteria !", false);

                        } else {

                            this.addAppFeedMessage(MessageSeverity.Error, "There was an error saving this search definition.  Error details: " + r.Message, false);
                        }
                    }
                });
            }
        }
    }

    public undo = (): void => {

        this.itemSearchRequest = this.appService.cloneObject(this.itemSearchRequestSnapshot);
        this.itemEnvelope = this.appService.cloneObject(this.itemEnvelopeSnapshot);
        this.itemEnvelope!.Document!.Item.SearchRequestJson = JSON.stringify(this.itemSearchRequest);

        this.isPendingChanges = false;
        this.setCloseButtonCaption.emit("CLOSE");
        this.saveButtonCaption = this.itemSearchRequest.IsAdvancedSearch ? "SAVE ADVANCED SEARCH" : "SAVE BASIC SEARCH";
    }

    public delete = (): void => {

        this.appService.showDialog(MessageSeverity.Info, "Confirm Deletion", "You are about to delete this search request.  If you are absolutely sure, click DELETE, otherwise CANCEL to return to the page", "DELETE", "CANCEL", false, false).subscribe((response: string) => {

            if (response == "DELETE") {

                this.searchRequestService.delete(this.itemEnvelope!.Document!.Item.SearchRequestId).subscribe((r: DeleteResult | null) => {

                    if (r) {

                        if (r.IsSuccess) {

                            this.setIsDataSourceAltered.emit(true);
                            this.closeContainerRequest.emit();

                        } else {

                            this.addAppFeedMessage(MessageSeverity.Error, "There was an error deleting this request.  Error Message: " + r.Message, false);
                        }
                    }
                });

            //} else {

            //    this.addAppFeedMessage(MessageSeverity.Error, "xxxyyyzzz. adsfasdfasdf asdfas fasd fads fasd fasdf dsfdfsdf", false);
            //    this.addAppFeedMessage(MessageSeverity.Warning, "Please be careful during any deletions and take a moment to think about what you are deleting", false);
            }
        });
    }

    public ngOnDestroy() { }

    public validateBeforeAccept(): boolean {

        let result: boolean = true;

        return result;
    }
}
